import Heading from '@components/Heading';
import Period from '@components/Period';
import Price from '@components/Price';
import { toNumber } from 'lodash';
import { useTranslation } from 'next-i18next';
import c from 'currency.js';
import { useSelector } from 'react-redux';
import {
  OrderItemBox,
  Text,
  LicensePlateHighlight,
  ProductPrice,
} from '../InvoiceOrderItems.module.css';

const OrderItem = ({ item, licensePlate, discount }) => {
  const { t } = useTranslation(['account', 'common', 'checkout']);
  const getItem = (itemType) => item.find(({ type }) => type === itemType);
  const { isSingle } = getItem('product');

  const {
    options: { vatPercentage },
  } = useSelector((state) => state.wordpress);

  const { isBusiness } = useSelector((state) => state.checkout);

  const vatPrice = () => {
    const vat = vatPercentage / 100;

    const product = getItem('product')?.amount || 0;
    const addon = getItem('addon')?.amount || 0;
    const reg = getItem('registration')?.amount || 0;
    const total = product + addon + reg;

    return total * vat;
  };

  return (
    <div className={OrderItemBox}>
      <table>
        <tbody>
          <tr>
            <td>
              <Heading size="extra-small">{getItem('product')?.name}</Heading>
            </td>
            <td className={ProductPrice}>
              <Price
                amount={toNumber(
                  c(getItem('product')?.amount, { fromCents: true })
                )}
                showDecimals
              />
            </td>
          </tr>
          {!isSingle && (
            <tr>
              <td colSpan={2}>
                <div className={`${Text} ${LicensePlateHighlight}`}>
                  {licensePlate} (
                  <Period period={getItem('product').period} />)
                </div>
              </td>
              <td />
            </tr>
          )}
          {getItem('addon') && (
            <tr>
              <td>{getItem('addon')?.name}</td>
              <td>
                <Price
                  amount={toNumber(
                    c(getItem('addon')?.amount, { fromCents: true })
                  )}
                  showDecimals
                />
              </td>
            </tr>
          )}
          {getItem('registration') && (
            <tr>
              <td>{t('signUpFee', { ns: 'checkout' })}</td>
              <td>
                <Price
                  amount={toNumber(
                    c(getItem('registration')?.amount, { fromCents: true })
                  )}
                  showDecimals
                />
              </td>
            </tr>
          )}
          {getItem('discount') && (
            <tr>
              <td>{getItem('discount')?.name}</td>
              <td>
                <Price
                  amount={toNumber(
                    c(getItem('discount')?.amount, { fromCents: true })
                  )}
                  showDecimals
                />
              </td>
            </tr>
          )}
          {isBusiness && (
            <tr>
              <td>{t('vat', { ns: 'checkout' })}</td>
              <td>
                <Price
                  amount={c(vatPrice(), { fromCents: true })}
                  showDecimals
                />
              </td>
            </tr>
          )}

          {getItem('product')?.primaryLocation?.name && (
            <tr>
              <td>{t('primaryWashHall', { ns: 'common' })}</td>
              <td>{getItem('product').primaryLocation.name}</td>
            </tr>
          )}

          {discount && (
            <>
              <br />
              <br />
              <tr>
                <td>
                  {t('washbackDiscount', {
                    ns: 'checkout',
                    product: discount?.name,
                  })}
                </td>
                <td>
                  <Price
                    amount={toNumber(c(discount?.amount, { fromCents: true }))}
                    showDecimals
                  />
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OrderItem;
